export default "__VITE_ASSET__ChJ7tWZ___"